if (typeof TNCMS_DotConnect_Tile !== 'number')
{
  TNCMS_DotConnect_Tile = 1;
}

// "Global" Array to prevent showing of duplicates.
//this is only needed for backwards compatability with ad.js
//once ad.js goes away then TNCMS_Used_Ad can be removed from this file
if (typeof TNCMS_Used_Ad == "undefined")
{
  TNCMS_Used_Ad = {};
}

//for backwards compatability with javascript implementations that don't have this built in...
if (!Object.create)
{
  //allow an object to be "copied" with out maintaining a relation to the original
  Object.create = function (o)
  {
    var F = function() {};
    F.prototype = o;
    return new F();
  };
}

if (typeof TNCMS_PAGE_LOADED !== 'boolean')
{
  TNCMS_PAGE_LOADED = false;

  function pageLoaded()
  {
    TNCMS_PAGE_LOADED = true;
  }

  //if the standard event listener exists use it...
  if (window.addEventListener)
  {
    window.addEventListener('load', pageLoaded, false);//W3C
  }

  //otherwise try the IE event listener
  else if (window.attachEvent)
  {
    window.attachEvent('onload', pageLoaded);//IE
  }
  
  //if neither of those exists just try directly using the window.onload event...
  else
  {
    priorOnLoad = window.onload;

    if (typeof window.onload != 'function')
    {
      window.onload = pageLoaded;
    }
    else
    {
      window.onload = function()
      {
        if (priorOnLoad)
        {
          priorOnLoad();
        }

        pageLoaded();
      };
    }
  }
}

if (!window.TNCMS)
{
  window.TNCMS = {};
}

if (!window.TNCMS.AdManager)
{
  window.TNCMS.AdManager = (function()
  {
    //private varibles
    var kDomain = {};
    var kPositionList = {};
    var kRenderedPositionList = {};
    var sDefaultDomain = null;
    var kGoogleSlots = {}; //For tracking dotconnect ad slots.
    
    var sDefaultSecureDomain = null; 

    /**
     * Used to know if we are in secure mode so the proper
     * domain can be used for rendering.
     */
    var isSecure = location.protocol == 'https:' ? true : false;
    
    var kAdList = {};
    var aRenderAdList = [];
    //when the global variable TNCMS_Used_Ad is removed then kUsedAd can be used again...
    //var kUsedAd = {};
    var iDebug = location.search.match(/(\?|\&)adman_debug_mode=(\d+)/) ? RegExp.$2 : 0;
    var bCanLog = false;
    var kLocation = false;
    var bTracker = false;
    var kImpressions = {};
    var kTraffic = {};
    var kSettings = {};
    
    var kAdCallback = 
    {
      dotconnect: function(oAd)
      {
          //Set the section of where we are. One level deep.
          var sPath = window.location.pathname;
          var aSections = sPath.split("/");
          var sSecondLevel = "frontpage";
          var sSiteName = oAd.domain.replace("www.","");

          if(aSections.length > 1 && aSections[1].indexOf(".") == -1)
          {
              sSecondLevel = aSections[1];
          }

          //Get the ad position relative to the 'fold'.
          var sFoldPosition = "";
          if (oAd.fold)
          {
              if (oAd.fold == 'above')
              {
                  sFoldPosition = "atf";
              }
              else if (oAd.fold == 'below')
              {
                  sFoldPosition = "btf";
              }
              else if (oAd.fold == 'span')
              {
                  sFoldPosition = "stf";
              }
          }

          //Create the google tag Js file in the header of the page. 
          if (!window.googletag)
          {
              window.googletag = {};
              if (document.getElementById('dotconnect-gpt-load') === null)
              {
                  var gads = document.createElement('script');
                  gads.id = 'dotconnect-gpt-load';
                  gads.async = true;
                  gads.type = 'text/javascript';
                  var useSSL = 'https:' == document.location.protocol;
                  gads.src = (useSSL ? 'https:' : 'http:') +
                      '//www.googletagservices.com/tag/js/gpt.js';
                  var node = document.getElementsByTagName('head')[0];
                  node.appendChild(gads,node);
              }
          }

          //Use the google tag object
          var googletag = window.googletag || {};
          googletag.cmd = googletag.cmd || [];
          //If the slot already exists, this is a refresh.
          if(kGoogleSlots[oAd.adid])
          {
              googletag.pubads().refresh([kGoogleSlots[oAd.adid]]);
          }else
          {
        	  while ( oAd.positionDiv && oAd.positionDiv.firstChild ) {
        		  oAd.positionDiv.removeChild(oAd.positionDiv.firstChild);
        	  }
        	  
              googletag.cmd.push(function() {
                  kGoogleSlots[oAd.adid] = googletag.defineSlot('/132916964/' + sSiteName, 
            		  [parseInt(oAd.width), parseInt(oAd.height)],
                      oAd.positionDiv.id
                  ).addService(
                      googletag.pubads()
                  ).setTargeting('pos', sFoldPosition);
                  
                  googletag.pubads().setTargeting('sec',sSecondLevel);
                  googletag.enableServices();
                  googletag.display(oAd.positionDiv.id);
              });
              
              oAd.positionDiv.className = 'tncms-iq-ad';
              //Increase the counter to keep ads under 16 
              TNCMS_DotConnect_Tile++;
          }
      },
      expandable: function(oAd)
      {
        var alt = oAd.title ? oAd.title : '*';
        var sHTML = '<img src="' + oAd.smallImage + '" alt="' + alt + '" border="0" id="expandable_' + oAd.adid + '" onmouseover="document.getElementById(\'expandable_' + oAd.adid + '\').src = \'' + oAd.largeImage + '\'" onmouseout="document.getElementById(\'expandable_' + oAd.adid + '\').src = \'' + oAd.smallImage + '\'"/>';

        if (oAd.clickuri)
        {          
          sHTML = '<a rel="nofollow" href="http:' + oAd.clickuri + '" target="_blank">' + sHTML + '</a>';
        }

        oAd.positionDiv.innerHTML = sHTML;
      },
      html5: function(oAd)
      {
          if(oAd.positionDiv.hasChildNodes())
          {
              info("Position " + oAd.position + 
                  " has child nodes. Removing child nodes for refresh."
              );

              while(oAd.positionDiv.firstChild)
              {
                  oAd.positionDiv.removeChild(oAd.positionDiv.firstChild);
              }
          }

          var oIframe = document.createElement('iframe');
          oIframe.setAttribute('id','html5-ad-frame-' + oAd.adid);
          oIframe.setAttribute('width',oAd.width);
          oIframe.setAttribute('height',oAd.height);
          oIframe.setAttribute('marginwidth',0);
          oIframe.setAttribute('marginheight',0);
          oIframe.setAttribute('hspace',0);
          oIframe.setAttribute('vspace',0);
          oIframe.setAttribute('frameborder',0);
          oIframe.setAttribute('scrolling','no');
          
          oIframe.setAttribute('sandbox', 
    		  'allow-forms allow-popups allow-same-origin allow-scripts'
		  );
          
          var sSrc= 'https://' + oAd.cdn + 
              '/content/tncms/ads/__html5/' + 
              oAd.uuid + '/' + 
              oAd.html5_id + '/' + 
              oAd.htmlfile;

          if(oAd.clickuri){sSrc += '?clickTag=' + encodeURIComponent(oAd.clickuri);}

          oIframe.src = sSrc;
          oAd.positionDiv.appendChild(oIframe);
      },
      html: function(oAd){	   
          if(oAd.height != null && oAd.height != ""){
              if(oAd.positionDiv.hasChildNodes()){
                  info("Position " + oAd.position + 
                      " has child nodes. Removing child nodes for refresh.");
                  while(oAd.positionDiv.firstChild){
                      oAd.positionDiv.removeChild(oAd.positionDiv.firstChild);
                  }
              }
              var oIframe = document.createElement('iframe');
              oIframe.setAttribute('id','html-ad-frame-' + oAd.adid);
              oIframe.setAttribute('width',oAd.width);
              oIframe.setAttribute('height',oAd.height);
              oIframe.setAttribute('marginwidth',0);
              oIframe.setAttribute('marginheight',0);
              oIframe.setAttribute('hspace',0);
              oIframe.setAttribute('vspace',0);
              oIframe.setAttribute('frameborder',0);
              oIframe.setAttribute('scrolling','no');
              
              var sUserHTML = '<script type="text/javascript">var ';
              sUserHTML += 'inDapIF = true;</scr' + 'ipt>' + oAd.html;
              sUserHTML = sUserHTML.replace(/[-[\]\/{}()*+?.\\^$|'"]/g, '\\$&');
              oIframe.src = "javascript:'" + sUserHTML + "'";
              oAd.positionDiv.appendChild(oIframe);
          }else{	
              //Loads the ad HTML into the inner HTML of the position div. It then loads the child nodes in that position div to an array that it will loop through later.
              oAd.positionDiv.innerHTML = oAd.html;
              aChildNode = oAd.positionDiv.childNodes;
              
              //this will stop when the first aChildNode[i] is invalid...
              // Looping through the child nodes of the ad position div.
                     
              for (var i = 0; aChildNode[i]; i++)
              {
                  //make sure the node name is 'script' and the type is either not set or is set to text/javascript
                  
                  if (aChildNode[i].nodeName && aChildNode[i].nodeName.toLowerCase() === 'script' && (!aChildNode[i].type || aChildNode[i].type.toLowerCase() === 'text/javascript'))
                  {
                      oNode = aChildNode[i].parentNode ? aChildNode[i].parentNode.removeChild(aChildNode[i]) : aChildNode[i];
                      
                      //If there is a src in the node use the jsLoader object to load the script.
                     if (oNode.src)
                     {
                         info('Ad #' + oAd.adid + ': Loading script: ' + oNode.src + ' on ' + oAd.position);
                         //Attempt to create ad without using jsLoader.
                         jsLoader.loadScript(oNode.src, 'blox-ad-position-' + oAd.position);              
                     }
                     else //Not sure what this does. Some sort of inline js creating code.
                     {
                         info('Ad #' + oAd.adid + ': Running inline script: on ' + oAd.position);
                         sData = oNode.text || oNode.textContent || oNode.innerHTML || "";
                         var oHead = document.getElementsByTagName('head')[0] || document.documentElement;
                         var oScript = document.createElement('script');
                         oScript.type = 'text/javascript';
                         oScript.appendChild(document.createTextNode(sData));
                         //Preserve the original document.write function. Will be overloading document.write
                         oldDocumentWrite = document.write;
                         //Overriding the document.write function.
                         document.write = function(sString)
                         {
                             oAd.positionDiv.innerHTML += sString;
                         };
                         oHead.insertBefore(oScript, oHead.firstChild);
                         oHead.removeChild(oScript);
                         document.write = oldDocumentWrite;
                     }
                     if (oNode.parentNode)
                     {
                         oNode.parentNode.removeChild(oNode);
                     }
                 }
             }
         }//End Else 
     },
      image: function(oAd)
      {
        alt = oAd.title ? oAd.title : '*';
        sHeight = oAd.height ? ' height="' + oAd.height + '"' : '';
        sWidth = oAd.width ? ' width="' + oAd.width + '"' : '';
        sOnClick = '';

        if (oAd.clickuri)
        {
            sOnClick = ' onclick="window.open(\'' + oAd.clickuri + '\',\'_blank\');" style="cursor: pointer;"';
        }

        oAd.positionDiv.innerHTML = '<img src="' + oAd.asseturl + '" alt="' + alt + '" border="0"' + sHeight + sWidth + sOnClick + '/>';
      },
      pagecurl: function ( oAd ) {
    	 // Stub
      },      
      text: function(oAd)
      {
          oAd.positionDiv.innerHTML = '<a rel="nofollow" href="' + oAd.clickuri + '" target="_blank">' + oAd.title + '</a><br />' + oAd.text;
      },
      video: function(oAd)
      {
    	  renderStandaloneVideo(oAd);
      }
    };
    
    var kVirtualRegionCallback =
    {
      popunder: function(oAd)
      {

        if ( oAd.type == 'expandable' || oAd.type == 'pagecurl' )
        {
          throw new Error('Ad type ' + oAd.type + 'is not allowed in a popunder.');
        }

        //create the popunder window
        iWidth = !oAd.width ? 300 : parseInt(oAd.width, 10) + 30;
        iHeight = !oAd.height ? 300 : parseInt(oAd.height, 10) + 100;
        iLeft = (screen.width - iWidth) / 2;
        iTop = (screen.height - iHeight) / 2;
        oAd.window = window.open('', 'tncms_adman_popunder', 'top=' + iTop + ', left=' + iLeft + ',width=' + iWidth + ',height=' + iHeight + ',scrollbars=0,resizable=0,toolbar=0,location=0,menubar=0,status=0,directories=0');

        //assign the body of the popunder window to be the ad's positionDiv
        oAd.positionDiv = oAd.window.document.body;
        oAd.positionDiv.setAttribute('id', 'blox-ad-position-' + oAd.position);

        //initialize the ad div to make sure it's properly empty 
        oAd.positionDiv.innerHTML = '';

        //attempt to push the new window under the old one
        oAd.window.blur();
        window.focus();

        //attempt to manipulate new window's title, size and location on screen 
        oAd.window.document.title = oAd.title;
        oAd.window.resizeTo(iWidth, iHeight);
        oAd.window.moveTo(iLeft, iTop);

        //create and display ad
        renderAd(oAd);
      },
      popup: function(oAd)
      {
        //create the black out effect to make the ad "modal"
        var oBlackOutDiv = document.createElement('div');
        oBlackOutDiv.setAttribute('id', 'BlackOutDiv');
        oBlackOutDiv.style.position = 'fixed';
        oBlackOutDiv.style.top = 0;
        oBlackOutDiv.style.left = 0;
        oBlackOutDiv.style.width = '100%';
        oBlackOutDiv.style.height = '100%';
        oBlackOutDiv.style.zIndex = 99999;
        oBlackOutDiv.style.backgroundColor = 'black';
        oBlackOutDiv.style.opacity = 0.9;
        oBlackOutDiv.style.filter = 'alpha(opacity=90)';

        if (typeof window.innerWidth == 'number')
        {
          //Non-IE
          iWinWidth = window.innerWidth;
          iWinHeight = window.innerHeight;
        }
        else if (document.documentElement && (document.documentElement.clientWidth || document.documentElement.clientHeight))
        {
          //IE 6+ in 'standards compliant mode'
          iWinWidth = document.documentElement.clientWidth;
          iWinHeight = document.documentElement.clientHeight;
        }
        else if (document.body && (document.body.clientWidth || document.body.clientHeight))
        {
          //IE 4 compatible
          iWinWidth = document.body.clientWidth;
          iWinHeight = document.body.clientHeight;
        }
        else
        {
          throw new Error('No valid hight or width for the current window could be found');
        }

        iWidth = oAd.width || 400;
        iHeight = oAd.height || 400;
        iAdLeft = parseInt((iWinWidth - iWidth) / 2),
        iAdLeft = iAdLeft > 0 ? iAdLeft : 0;
        iAdTop = parseInt((iWinHeight - iHeight) / 2);
        iAdTop = iAdTop > 0 ? iAdTop : 0;

        //create the position div that the ad will be written to
        var oPositionDiv = document.createElement('div');
        oPositionDiv.style.position = 'absolute';
        oPositionDiv.style.top = iAdTop + 'px';
        oPositionDiv.style.left = iAdLeft + 'px';
        oPositionDiv.style.zIndex = parseInt(oBlackOutDiv.style.zIndex) + 1;
        oPositionDiv.setAttribute('id', 'blox-ad-position-_popup1');

        function blackOutDivClick()
        {
          document.getElementsByTagName('body')[0].removeChild(document.getElementById('blox-ad-position-_popup1'));
          document.getElementsByTagName('body')[0].removeChild(document.getElementById('BlackOutDiv'));
        }

        if (typeof oBlackOutDiv.addEventListener != 'undefined')
        {
          oBlackOutDiv.addEventListener('click', blackOutDivClick, false);//W3C
        }
        else//IE
        {
          if (document.compatMode == 'BackCompat')//quirks mode...
          {
            oBlackOutDiv.style.width = '110%';
            oBlackOutDiv.style.height = '110%';
            oBlackOutDiv.style.position = 'absolute';
          }

          oBlackOutDiv.attachEvent('onclick', blackOutDivClick);
        }

        //add the black out div to the body dom
        document.getElementsByTagName('body')[0].appendChild(oBlackOutDiv);

        //add the position div to the dom
        document.getElementsByTagName('body')[0].appendChild(oPositionDiv);
        oAd.positionDiv = document.getElementById('blox-ad-position-_popup1');

        //process the regualr ad callback
        renderAd(oAd);
      }
    };

    //private init code
    if (iDebug > 0)
    {
      if (typeof console == "undefined")
      {
        alert('Please turn on the debugging console!');
      }
      else
      {
        info('Debug level set to: ' + iDebug);
        bCanLog = true;
      }
    }

    if (window.XMLHttpRequest)
    {
      oReq = new XMLHttpRequest();
    }
    else if (window.ActiveXObject)
    {
      oReq = new ActiveXObject("MSXML2.XMLHTTP.3.0");
    }

    if (oReq)
    {
      oReq.onreadystatechange = function()
      {
        if (oReq.readyState == 4 && oReq.status == 200)
        {
          var oResponse = eval("(" + oReq.responseText + ")");

          //if the lat and/or long isn't numeric then there are no proper
          //coordinates set for this IP so we can discard the info...
          if (oResponse['lat'] !== '' && oResponse['long'] !== '')
          {
            kLocation = {'lat': oResponse['lat'], 'long': oResponse['long']};
          }
        }
      };
      
      try
      {
        oReq.open("GET", "/_services/v1/client_ip_info/");
        oReq.send();
      }
      catch (e) {}
    }

    //add some debug code use adman_debug_time=10/17/2010_16-30 (military time) in querystring for page
    //to override the date object used for dayparting full date time required.
    aTime = location.search.match(/(\?|\&)adman_debug_time=(\d\d)\/(\d\d)\/(\d\d\d\d)_(\d\d)-(\d\d)/);
    oCurrent = aTime ? new Date(aTime[4], aTime[2]-1, aTime[3], aTime[5], aTime[6]) : new Date();

    //bounds are in 15 min increments
    //so current boundry is current hours * 4 + 1 / full quarter of an hour
    sBound = oCurrent.getHours() * 4 + Math.floor(oCurrent.getMinutes() / 15);
    var oDayPart = {day: oCurrent.getDay(), startBound: sBound, endBound: sBound + 1};
    delete aTime;
    delete oCurrent;
    delete sBound;
    aTag = document.getElementsByTagName('meta');
    oKeyword = {};
    aKeyword = [];

    for (var i = 0; i < aTag.length; i++)
    {
      if (aTag[i].name.toLowerCase() == 'keywords')
      {
        aTemp = aTag[i].content.split(',');

        for (var j = 0; j < aTemp.length; j++)
        {
          sTemp = aTemp[j].replace(/^\s+|\s+$/g,"");

          //push the temp name onto an object to keep the names unique
          //add a space on either end to narrow the search to the whole word and not just a part of it
          //only add the word if it's not empty
          if (sTemp)
          {
            oKeyword[' ' + sTemp + ' '] = 1;
          }
        }
      }
    }

    //push each now unique keyword on to the keyword list
    for (var s in oKeyword)
    {
      aKeyword.push(s);
    }

    //lowercase the keywords so the search can be case insensitive
    var sMetaKeywords = aKeyword.join(',').toLowerCase();
    delete aTag;
    delete oKeyword;
    delete aKeyword;

    docPath = document.location.href.replace(/\?.*/, '').replace(/#\w+/, '');
    sPath = '';
    
    if (docPath.match(/^https:\/\/.+\/\-(\/[^#?\s]+)/))
    {
        sPath = RegExp.$1.replace(/\/[a-z0-9_\-]+\..+$/i, '');
    } else if (docPath.match(/^((http|ftp|https):\/)?\/?([^:\/\s]+)((\/[\w\-\.]+)*\/)([\w\-\.]+\.[^#?\s]+)(#[\w\-]+)?$/))
    {
      sPath = RegExp.$4;
    }
    else if (docPath.match(/^((http|ftp|https):\/)?\/?([^:\/\s]+)((\/[\w\-\.]+)*\/)?$/))
    {
      sPath = RegExp.$4;
    }

    var sDefaultSection = sPath == '/' ? 'frontpage' : sPath.replace(/^\//, '').replace(/\/$/, '');
    delete docPath;
    delete sPath;

    for (regionType in kVirtualRegionCallback)
    {
      if (typeof window['tncms_virtual_region_' + regionType] == 'function')
      {
        kVirtualRegionCallback[regionType] = window['tncms_virtual_region_' + regionType];
      }
    }

    //private methods
    function init(oConfig)
    {
      oConfig = oConfig || {};

      if (oConfig.debug)
      {
        iDebug = oConfig.debug;

        if (iDebug > 0)
        {
          if (typeof console == "undefined")
          {
            alert('Please turn on the debugging console!');
          }
          else
          {
            info('Debug level set to: ' + iDebug);
            bCanLog = true;
          }
        }
      }
      
      if ( oConfig.domain ) {
    	  oConfig.domain = normDomain(oConfig.domain);
      }

      //try to load domainConfig
      if (domainConfig(oConfig))
      {
        //if the config doesn't contain position data
        if (!oConfig.slot)
        {
          //then set the domain defaults
          if (sDefaultDomain)
          {
            warn('Changing the default domain from ' + sDefaultDomain + ' to ' + oConfig.domain + '.');
          }
          else
          {
            info('Setting the default domain to ' + oConfig.domain + '.');
          }

          sDefaultDomain = oConfig.domain;
          sDefaultSecureDomain = oConfig.secureDomain;
        }

        if (!window.TNCMS.Tracking && !bTracker)
        {
          info('Start loading tracking script');
          bTracker = 'loading';
          loadScript(oConfig, '/shared-content/art/tncms/tracking.js', function ()
          {
            bTracker = true;
            info('Finished loading tracker script');
            renderAll();
          });
        }
        else if (window.TNCMS.Tracking && !bTracker)
        {
          bTracker = true;
        }
      }

      if (oConfig['virtualregion'])
      {
        for (regionType in kVirtualRegionCallback)
        {
          if (oConfig['virtualregion'] && oConfig['virtualregion'][regionType])
          {
            kVirtualRegionCallback[regionType] = oConfig['virtualregion'][regionType];
          }
        }
      }

      if ( oConfig['callback'] ) {
        for ( adType in kAdCallback )  {
          //they are never allowed to override the dotconnect function...
          if ( adType == 'dotconnect' || adType == 'html' || adType == 'video' ) {
        	  continue;
          }

          if ( oConfig['callback'] && oConfig['callback'][adType] ) {
        	  kAdCallback[adType] = oConfig['callback'][adType];
          }
        }
      }
      
    }

    function setImpressions(sDomain, oImpressions)
    {
    	sDomain = normDomain(sDomain);
      kImpressions[sDomain] = oImpressions;
    }

    function setTraffic(sDomain, oTraffic)
    {
    	sDomain = normDomain(sDomain);
      kTraffic[sDomain] = oTraffic;
    }

    function setSettings(sDomain, oSettings)
    {
    	sDomain = normDomain(sDomain);
      kSettings[sDomain] = oSettings;
      
      if (kSettings[sDomain]['trafficSmoothing'])
      {
        info('Traffic smoothing active on ' + sDomain);
      }
    }

    function info(message)
    {
      if (iDebug & 1 && bCanLog)
      {
        console.info(message);
      }
    }

    function warn(message)
    {
      if (iDebug & 2 && bCanLog)
      {
        console.warn(message);
      }
    }

    function error(message)
    {
      if (iDebug & 4 && bCanLog)
      {
        console.error(message);
      }
    }
    
    function loadScript(oConfig, sScriptPath, functionName)
    {
      oConfig = oConfig || {};

      if (!oConfig.domain || !oConfig.secureDomain)
      {
        throw new Error('Failed to load script (' + sScriptPath + '): valid domain data not detected');
      }

      domain = location.protocol == 'https:' ? oConfig.secureDomain : oConfig.domain;
      var oScript = document.createElement('script');
      oScript.src = location.protocol + '//' + domain + sScriptPath;
      oScript.type = 'text/javascript';
      document.getElementsByTagName('head')[0].appendChild(oScript);

      if (typeof functionName == 'function')
      {
        if (typeof oScript.addEventListener != 'undefined')
        {
          oScript.addEventListener('load', functionName, false);//W3C
        }
        else
        {
          function handleIeState()
          {
            if (oScript.readyState == 'loaded')
            {
              functionName();
            }
          }

          oScript.attachEvent('onreadystatechange', handleIeState);//IE
        }
      }      

      return oScript;
    }
    
    function normDomain(sDomain) {
    	if (sDomain && sDomain.length > 0 ) {
    		return sDomain.replace(/^www\./i, '');
    	}    	
    	return '';
    }

    /* {{{ positionIsAutoPlay( oAd ) */
    
    /**
     * Check if videos in this position should auto play.
     * By default video_autoplay is set to 0 (false).
     * 
     * @var object AdManager Position
     * @return bool
     */
    function positionIsAutoPlay( oAd ) {
    	return getPositionSetting(oAd, 'video_autoplay', 0) == 1;
    }
    
    /* }}} */
    /* {{{ getPositionSetting( oAd, sSetting, xDefault ) */
    
    /**
     * Get a position setting and return the default if
     * it doesn't exist or equals the set value.
     * 
     * @param object AdManager Ad
     * 	The fully populated Ad after getAd has been called
     * @param string Setting to look for
     * @param mixed The default value to compare
     * @return mixed xDefault|Value
     */
    function getPositionSetting(oAd, sSetting, xDefault ) {
    	if ( ! kSettings ) {
    		warn("Settings not loaded");
    		return xDefault;
    	}
    	
    	var sDomain = normDomain(sDefaultDomain);
    	var sPosition = oAd.region;
    	var sSlot = oAd.slot;    
    	var sSection = oAd.section;
    	
    	if ( ! kSettings[sDomain] ) {
    		warn("No settings found for: " + sDomain);
    		return xDefault;
    	}
    	
    	if ( ! kSettings[sDomain][sPosition] ) {
    		warn("No position settings for: " + sPosition);
    		return xDefault;
    	}
    	
    	if ( ! kSettings[sDomain][sPosition][sSlot] ) {
    		warn("No slot settings for: " 
				+ sPosition + " at slot: " + sSlot
			);    		
    		return xDefault;
    	}
    	
    	if ( ! kSettings[sDomain][sPosition][sSlot][sSection] ) {
    		warn("No slot settings for: " 
				+ sPosition + " at slot: " + sSlot + ' with section: ' + sSection
			);    		
    		return xDefault;
    	}    	
    	
    	if ( kSettings[sDomain][sPosition][sSlot][sSection][sSetting] 
    		&& kSettings[sDomain][sPosition][sSlot][sSection][sSetting] != xDefault
    	) {
    		return kSettings[sDomain][sPosition][sSlot][sSection][sSetting];
    	}
    	
    	return xDefault;
    }
    
    /* }}} */
    
    function domainConfig(oConfig)
    {
      if (!oConfig.domain || !oConfig.secureDomain)
      {
        return false;
      }
      
      var sDomain = normDomain(oConfig.domain);

      //if there is anything set in kDomain[oConfig.domain] then the domainConfig process for that domain
      //has already started, move on
      if (kDomain[sDomain])
      {
        return true;
      }

      //if all of the following variables are already set then domainConfig doesn't need to be called again...
      if (kImpressions[sDomain] && kTraffic[sDomain] && kSettings[sDomain])
      {
        info('Using existing configs for ' + sDomain);
        kPositionList[sDomain] = kPositionList[sDomain] || [];
        kDomain[sDomain] = true;
        return true;
      }

      if (kImpressions[sDomain])
      {
        info('Using existing impression data for ' + sDomain);
      }
      else
      {
        info('Start loading impression data for ' + sDomain);
        loadScript(oConfig, '/content/tncms/ads/impressions.js', function ()
        {
          info('Finished loading impression data for ' + sDomain);

          //if traffic data and settings are already loaded then any ads waiting for that domain can be rendered
          if (kTraffic[sDomain] && kSettings[sDomain])
          {
            kDomain[sDomain] = true;
            renderDomain(sDomain);
          }
        });
      }

      if (kTraffic[sDomain])
      {
        info('Using existing traffic data for ' + sDomain);
      }
      else
      {
        info('Start loading traffic data for ' + sDomain);
        loadScript(oConfig, '/content/tncms/ads/traffic.js', function ()
        {
          info('Finished loading traffic data for ' + sDomain);

          //if impression data and settingsd are already loaded then any ads waiting for that domain can be rendered
          if (kImpressions[sDomain] && kSettings[sDomain])
          {
            kDomain[sDomain] = true;
            renderDomain(sDomain);
          }
        });
      }

      if (kSettings[sDomain])
      {
        info('Using existing settings for ' + sDomain);
      }
      else
      {
        info('Start loading settings for ' + sDomain);
        loadScript(oConfig, '/content/tncms/ads/settings.js', function ()
        {
          info('Finished loading settings for ' + sDomain);

          //if impression data and traffic data are already loaded then any ads waiting for that domain can be rendered
          if (kImpressions[sDomain] && kTraffic[sDomain])
          {
            kDomain[sDomain] = true;
            renderDomain(sDomain);
          }
        });
      }

      kPositionList[sDomain] = [];
      kDomain[sDomain] = 'loading';
      return true;
    }

    function render(oPosition)
    {
      oPosition = oPosition || {};
      init(oPosition);
      oPosition.domain = oPosition.domain || sDefaultDomain;
      oPosition.secureDomain = oPosition.secureDomain || sDefaultSecureDomain;

      if (!oPosition.region || !oPosition.slot)
      {
        warn('No valid position');
        warn(oPosition);
        return false;
      }

      aRegionType = oPosition.region.match(/^\_(.*)$/);
      oPosition.regionType =  aRegionType && aRegionType[1] ? aRegionType[1] : 'inline';

      if (!document.getElementById('blox-ad-position-' + oPosition.region + oPosition.slot) && oPosition.regionType == 'inline')
      {
        if (TNCMS_PAGE_LOADED)
        {
          warn('The div for position (' + oPosition.region + oPosition.slot + ') does not exist!');
          return false;
        }

        document.write("\n<div id=\"blox-ad-position-" + oPosition.region + oPosition.slot +  "\"></div>\n");
      }

      return renderPosition(oPosition);
    }

    function renderDomain(sDomain)
    {
    	sDomain = normDomain(sDomain);
    	
      if (bTracker !== true)
      {
        info('Rendering deferred for ' + sDomain + ': Tracker script has not been loaded');
        return false;
      }

      if (kDomain[sDomain] !== true)
      {
        info('Rendering deferred for ' + sDomain + ': Config scripts have not been loaded');
        return false;
      }

      if (kPositionList[sDomain].length == 0)
      {
        info('No positions for ' + sDomain + ' currently need rendering');
        return false;
      }

      while (oConfig = kPositionList[sDomain].shift())
      {
        renderPosition(oConfig);
      }
    }

    function refresh(oRefresh)
    {
      oRefresh = oRefresh || {};

      if (oRefresh.all)
      {
        for (sDomain in kRenderedPositionList)
        {
          refresh({'domain': sDomain});
        }

        return true;
      }
      
      if ( oRefresh.domain ) {
    	  oRefresh.domain = normDomain(oRefresh.domain);
      } 

      if (oRefresh.region && oRefresh.slot)
      {
        //if they leave out the domain then assume it should be the default domain
        sDomain = oRefresh.domain || sDefaultDomain;

        if (kRenderedPositionList[sDomain] && kRenderedPositionList[sDomain][oRefresh.region] && kRenderedPositionList[sDomain][oRefresh.region][oRefresh.slot])
        {
          if (!kSettings[oRefresh.domain][oRefresh.region] || !kSettings[oRefresh.domain][oRefresh.region].refreshable)
          {
            info('Ads for ' + sDomain + ' in ' + oRefresh.region + ' are not refreshable.');
            return false;
          }

          info('Refreshing ads for ' + sDomain + ' in ' + oRefresh.region + oRefresh.slot);
          renderPosition(kRenderedPositionList[sDomain][oRefresh.region][oRefresh.slot]);
        }

        return true;
      }

      if (oRefresh.region)
      {
        //if they leave out the domain then assume it should be the default domain
        sDomain = oRefresh.domain || sDefaultDomain;

        if (!kSettings[sDomain][oRefresh.region] || !kSettings[sDomain][oRefresh.region].refreshable)
        {
          info('Ads for ' + sDomain + ' in ' + oRefresh.region + ' are not refreshable.');
          return false;
        }

        for (sSlot in kRenderedPositionList[sDomain][oRefresh.region])
        {
          oRefresh.slot = sSlot;
          refresh({domain: sDomain, region: oRefresh.region, slot: sSlot});
        }

        return true;
      }

      //if they leave out the domain then assume it should be the default domain
      sDomain = oRefresh.domain || sDefaultDomain;

      if (!kRenderedPositionList[sDomain])
      {
        info('No ads to refresh for ' + sDomain);
        return false;
      }

      for (sRegion in kRenderedPositionList[sDomain])
      {
        refresh({domain: sDomain, region: sRegion});
      }

      return true;
    }

    function renderAll()
    {
      if (bTracker !== true)
      {
        info('Rendering deferred: Tracker script has not been loaded');
        return false;
      }

      for (sDomain in kPositionList)
      {
        renderDomain(sDomain);
      }

      while (oAd = aRenderAdList.shift())
      {
        renderAd(oAd);
      }
    }

    function renderPosition(oPosition)
    {
      oPosition = oPosition || {};
      
      if ( oPosition.domain ) {
    	  oPosition.domain = normDomain(oPosition.domain);
      }

      if (kDomain[oPosition.domain] !== true || bTracker !== true)
      {
        kPositionList[oPosition.domain] = kPositionList[oPosition.domain] || [];
        kPositionList[oPosition.domain].push(oPosition);
        return true;
      }
      
      //check for this position's frequency cap cookie...
      sPositionCookie = readCookie('tncms_position_' + oPosition.region + '_' + oPosition.slot);
      
      if (sPositionCookie)
      {
        aData = sPositionCookie.split('&');
        iFrequency = parseInt(aData[0], 10);
        nMinutes = (new Date(unescape(aData[1])) - new Date()) / 60000;

        //if the expiration date for the cookie is still in the future
        if (nMinutes > 0)
        {
          //then generate a message to that effect and do no further processing on this position
          iMinutes = parseInt(nMinutes, 10);
          sMessage = 'The position ' + oPosition.region + oPosition.slot + ' has met its frequency cap, which is set to ' + iFrequency + ' minutes. This position will be available again in ';

          if (iMinutes == 0)
          {
            sMessage += 'under a minute.';
          }
          else if (iMinutes == 1)
          {
            sMessage += 'around a minute.';
          }
          else
          {
            sMessage +=  'around ' + iMinutes + ' minutes.';
          }

          warn(sMessage);
          sMessage = '<!-- ' + sMessage + ' -->';
          
          try
          {
            document.getElementById('blox-ad-position-' + oPosition.region + oPosition.slot).innerHTML = sMessage;
          }
          catch (e) {}
          return false;
        }
      }

      //initialize some data...
      oPosition.position = oPosition.region + oPosition.slot;
      oPosition.cdn = kSettings[oPosition.domain].cdn || null;
      oPosition.section = oPosition.section ? oPosition.section : sDefaultSection;
      kAdList[oPosition.domain] = kAdList[oPosition.domain] || {};
      kAdList[oPosition.domain][oPosition.region] = kAdList[oPosition.domain][oPosition.region] || {};
      kAdList[oPosition.domain][oPosition.region][oPosition.slot] = kAdList[oPosition.domain][oPosition.region][oPosition.slot] || false;

      if (!oPosition.adList && !kAdList[oPosition.domain][oPosition.region][oPosition.slot] && !oPosition['finalRender'])
      {
        info('Attempting to load ads for ' + oPosition.domain + ' in ' + oPosition.region + oPosition.slot);
        loadScript(oPosition, '/content/tncms/ads/' + escape(oPosition.region) + '/' + oPosition.slot + '.js', function ()
        {
          info('Finished loading ads for ' + oPosition.domain + ' in ' + oPosition.region + oPosition.slot);
          oPosition['finalRender'] = true;
          return renderPosition(oPosition);
        });               
        return false;
      }

      //now that ads have been cached add positions to kRenderedPositionList
      if (!kRenderedPositionList[oPosition.domain] || !kRenderedPositionList[oPosition.domain][oPosition.region] || !kRenderedPositionList[oPosition.domain][oPosition.region][oPosition.slot])
      {
        kRenderedPositionList[oPosition.domain] = kRenderedPositionList[oPosition.domain] || {};
        kRenderedPositionList[oPosition.domain][oPosition.region] = kRenderedPositionList[oPosition.domain][oPosition.region] || {};
        kRenderedPositionList[oPosition.domain][oPosition.region][oPosition.slot] = oPosition;
      }

      //scan the used ads for one that is already in this position,
      //if one is found remove it so it can be used again
      //when the global variable TNCMS_Used_Ad is removed then kUsedAd can be used again...
      for (iAd in TNCMS_Used_Ad)
      {
        if (TNCMS_Used_Ad[iAd] == oPosition.position)
        {
          info('Removing ad #' + iAd + ' from used ad list.');
          delete TNCMS_Used_Ad[iAd];
          break;
        }
      }

      try
      {
        info('Generating ad for ' + oPosition.domain + ' in ' + oPosition.position);
        oAd = getAd(oPosition);

        if (kVirtualRegionCallback[oAd.regionType])
        {
          return kVirtualRegionCallback[oAd.regionType](oAd);
        }

        return renderAd(oAd);
      }
      catch (oError)
      {
        if (oError.name == 'Warning')
        {
          warn(oError.message);
        }
        else
        {
          error(oError.message);
        }

        oPositionDiv = document.getElementById('blox-ad-position-' + oPosition.position);

        if (oPositionDiv)
        {
          oPositionDiv.innerHTML = '<!-- ' + oError.message +' -->';
        }
      }

      return false;
    }

    function renderAd(oCurrentAd)
    {
      if (!oCurrentAd.type)
      {
        throw new Error('No ad type was found.');
      }
      
      if ( ! kAdCallback[oCurrentAd.type] ) {
    	  throw new Error('No callback for type "' + oCurrentAd.type + ' was found.');
      }

      if ( kDomain[oCurrentAd.domain] !== true || bTracker !== true )
      {
    	  aRenderAdList.push(oCurrentAd);
    	  return true;
      }

      if (iDebug & 1 && bCanLog)
      {
        //clone the data so that when it is changed by a callback it isn't retroactivly changed in our console output! 
        var oTemp = {};

        for (x in oCurrentAd)
        {
          oTemp[x] = oCurrentAd[x];
        }

        info(oTemp);
      }     

      // Render the ad type
      kAdCallback[oCurrentAd.type](oCurrentAd);

      // Track the impression
            
      TNCMS.Tracking.addEvent({
		domain: TNCMS.AdManager.isSecure ? oCurrentAd.secureDomain : oCurrentAd.domain,
		app: 'bannerad',
		metric: 'impressions',
		id: oCurrentAd.section + '/' + oCurrentAd.position + '/' + oCurrentAd.uuid
      }); 
      
      //Mark the ad as used. 
      if (oCurrentAd.type != 'dotconnect')
      {
        //when the global variable TNCMS_Used_Ad is removed then kUsedAd can be used again...
        TNCMS_Used_Ad[oCurrentAd.adid] = oCurrentAd.position;
      }

      var sNormDomain = normDomain(oCurrentAd.domain);
      
      //create region frequency cap
      if (kSettings[sNormDomain][oCurrentAd.region][oCurrentAd.slot] && kSettings[oCurrentAd.domain][oCurrentAd.region][oCurrentAd.slot][oCurrentAd.section] && kSettings[oCurrentAd.domain][oCurrentAd.region][oCurrentAd.slot][oCurrentAd.section].frequency)
      {
        iFrequency = parseInt(kSettings[sNormDomain][oCurrentAd.region][oCurrentAd.slot][oCurrentAd.section].frequency, 10);

        if (iFrequency > 0 && !readCookie('tncms_position_' + oCurrentAd.region + '_' + oCurrentAd.slot))
        {
          var oDate = new Date();
          oDate.setTime(oDate.getTime() + (iFrequency * 60000));
          info('Creating frequency cookie for ' + oCurrentAd.region + oCurrentAd.slot + '. It will expire in ' + iFrequency + ' minutes.');
          document.cookie = 'tncms_position_' + oCurrentAd.region + '_' + oCurrentAd.slot + '=' + iFrequency + '&' + escape(oDate.toUTCString()) + '; expires=' + oDate.toUTCString() + '; path=/';
        }
      }

      if (oCurrentAd.frequency_limit)
      {
        sCookieName = 'tncms_ad_' + oCurrentAd.adid;
        sCookieValue = readCookie(sCookieName);

        if (sCookieValue)
        {
          //read the existing cookie and increment the value
          aData = sCookieValue.split('&');
          nAdCount = parseInt(aData[0], 10) + 1;
          info('Incrementing frequency limit cookie for ' + oCurrentAd.adid);
          document.cookie = sCookieName + '=' + nAdCount + '&' + aData[1] + '; expires=' + unescape(aData[1]) + '; path=/';
        }
        else
        {
          //create a new cookie
          if (oCurrentAd.frequency_number && oCurrentAd.frequency_type)
          {
            var oDate = new Date();

            switch (oCurrentAd.frequency_type)
            {
              case 'minutes':
                //60 * 1000
                oDate.setTime(oDate.getTime() + (oCurrentAd.frequency_number * 60000));
                break;

              case 'hours':
                //60 * 60 * 1000
                oDate.setTime(oDate.getTime() + (oCurrentAd.frequency_number * 3600000));
                break;

              case 'days':
                //24 * 60 * 60 * 1000
                oDate.setTime(oDate.getTime() + (oCurrentAd.frequency_number * 86400000));
                break;
            }

            var cookieExp = '; expires=' + oDate.toUTCString();
            info('Creating frequency limit cookie for ' + oCurrentAd.adid);
            document.cookie = sCookieName + '=1&' + escape(oDate.toUTCString()) + cookieExp + '; path=/';
          }
        }  
      }

      return true;
    }
    
    /* {{{ renderStandaloneVideo( oVideoAd ) */
    
    /**
     * Render the video ad as a standalone video player
     * using the <video> tag. This also tracks the clickthru 
     * of the ad.
     * 
     * @var Object AdManager Ad
     * @return void
     */
    function renderStandaloneVideo( oVideoAd ) {
    	if ( !oVideoAd ) {
    		warn("Could not render video. Missing required objects.");
    		return;
    	}
    	
    	if ( ! oVideoAd.asseturl.match(/\.mp4$/i) ) {
    		warn("Could not render video. Unsupported format.");
    		return;
    	}

    	// There is already a video here, see if it's the same one
    	// or a different one. Remove components if it's new return if it's not
    	
    	if ( oVideoAd.positionDiv.childNodes 
			&& oVideoAd.positionDiv.childNodes.length > 0
		) {
    		if ( document.getElementById(
    				'tncms-admanager-video-player-' + oVideoAd.adid
			) ) {
    			info("Ad already rendered.");
    			return;
    		}
    		
			for ( var nChild in oVideoAd.positionDiv.children ) {
				info("Removing existing child elements to render new ad.");
				
				if ( oVideoAd.positionDiv.children[nChild].nodeType !== 1 ) {
					continue;
				}				
				oVideoAd.positionDiv.removeChild(
					oVideoAd.positionDiv.children[nChild]
				);
			}
    	}
    	
    	info("Rendering standalone video");

    	// Get clickthru URI
    	
    	if ( oAd.clickuri ) {    		
        	// Create clickthru div and anchor
            
        	var oClickDiv = document.createElement('div');
        	oClickDiv.setAttribute('class', 'tncms-admanager-video-click-cnt');
        	
        	var oClickAnchor = document.createElement('a');
        	oClickAnchor.setAttribute('class', 'tncms-admanager-video-click-url');    	
        	oClickAnchor.setAttribute('href', oAd.clickuri );
        	oClickAnchor.setAttribute('target', oVideoAd.target || '_blank');
        	oClickAnchor.setAttribute('onclick', 'tncmsAdmanagerVideoCtrl(\'' + oVideoAd.adid + '\', \'pause\')');
        	oClickAnchor.innerHTML = 'Click here for details';              
    	}
        
    	// Create CSS
    	
    	var oCSS = document.createElement('style');
    	oCSS.appendChild(document.createTextNode(
    		'.tncms-admanager-video-cnt {'
    		+ ' width: 100%;'
    		+ ' height: 100%;'
    		+ ' text-align: center;'
    		+ '}' + "\n"
    		+ '.tncms-admanager-video-inner-cnt {'
    		+ ' display:inline-block;'
    		+ ' position:relative;'
    		+ '}' + "\n"
			+ '.tncms-admanager-video-click-cnt {'
    		+ ' position: absolute;'
    		+ ' right: 10px;'
    		+ ' top: 10px;'
    		+ ' z-index: 1;'
    		+ ' padding: 5px 5px;'
    		+ ' font-size: 16px;'
    		+ ' font-family: Helvetica;'
    		+ ' color: #FFF;'
    		+ ' background-color: rgba(50, 50, 50, 0.3);'
    		+ '}' + "\n"    
    		+ 'video {' 
    		+ ' width: 100%;'
    		+ ' height: 100%;'
    		+ '}' + "\n"
    		+ '.tncms-admanager-video-click-cnt a {'
    		+ ' color: #DDD;'
    		+ '}' + "\n"
		));
    	
    	// Create JS to pause video on link click
    	
    	var oJS = document.createElement('script');
    	oJS.setAttribute('type', 'text/javascript');
    	oJS.innerHTML = ' var tncmsAdmanagerVideoCtrl = function (sAdID, sAction) {'
    		+ '  var oPlayer = document.getElementById(\'tncms-admanager-video-player-\' + sAdID);'
    		+ '  if ( oPlayer ) {'
    		+ '    switch(sAction) { '
    		+ '       case \'pause\':'
    		+ '          oPlayer.pause();'
    		+ '          break;'
    		+ '       case \'play\':'
    		+ '         oPlayer.play();'
    		+ '         break;'
    		+ '    }'
    		+ '  }'
    		+ '} ';
    	
    	// Create base containers
    	
    	var oCntDiv = document.createElement('div');
    	oCntDiv.setAttribute('class', 'tncms-admanager-video-cnt');
    	oCntDiv.setAttribute('id', 'tncms-admanager-video-' + oVideoAd.adid);
    	
    	var oInnerDiv = document.createElement('div');
    	oInnerDiv.setAttribute('class', 'tncms-admanager-video-inner-cnt');
    	    	
    	// Create the base video tag

    	var oVideoTag = document.createElement('video');
    	oVideoTag.setAttribute('controls', '');
    	oVideoTag.setAttribute('loop', '');
    	oVideoTag.setAttribute('class', 'tncms-admanager-video');
    	oVideoTag.setAttribute('id', 'tncms-admanager-video-player-' + oVideoAd.adid);
    	oVideoTag.setAttribute('width', oVideoAd.width);
    	oVideoTag.setAttribute('height', oVideoAd.height);
    	if ( oVideoAd.poster ) {
    		oVideoTag.setAttribute('poster', oVideoAd.poster);
    	}    	
    	
    	if ( positionIsAutoPlay(oVideoAd) ) {
    		oVideoTag.setAttribute('autoplay', ''); 
    		oVideoTag.setAttribute('muted', '');
    	} else {
    		oVideoTag.setAttribute('onloadstart', "this.volume=0.5");
    	}
    	
    	// Create the source tag
    	
    	var oSourceTag = document.createElement('source');
    	oSourceTag.setAttribute('src', oVideoAd.asseturl);    	
    	oSourceTag.setAttribute('type', 'video/mp4');
    	
    	// Append elements
    	
    	oVideoTag.appendChild(oSourceTag);
    	oVideoTag.appendChild(document.createTextNode(
			'Video not supported by browser.'
		));
    	
    	if ( oClickAnchor && oClickDiv ) {
        	oClickDiv.appendChild(oClickAnchor);    	
        	oInnerDiv.appendChild(oClickDiv);    		
    	}

    	oInnerDiv.appendChild(oVideoTag);
    	
    	oCntDiv.appendChild(oInnerDiv);
    	
    	// Show the video 
    	
    	oVideoAd.positionDiv.appendChild(oCSS);
    	oVideoAd.positionDiv.appendChild(oJS);
    	oVideoAd.positionDiv.appendChild(oCntDiv);
    }
    
    /* }}} */

    function setAds(sAdDomain, sAdRegion, sAdSlot, oAdList)
    {
    	var sNormDomain = normDomain(sAdDomain);
    	
      //if the domain's ads haven't been initialized yet then do it
      kAdList[sNormDomain] = kAdList[sNormDomain] || {};
      kAdList[sNormDomain][sAdRegion] = kAdList[sNormDomain][sAdRegion] || {};
      kAdList[sNormDomain][sAdRegion][sAdSlot] = oAdList;
    }

    function getAd(oPosition)
    {    	
    	var sNormDomain = normDomain(oPosition.domain);
    	
    	
      if (oPosition.adList)
      {
        info('Caching passed ads for ' + oPosition.domain + ' in ' + oPosition.region + oPosition.slot);
        setAds(oPosition.domain, oPosition.region, oPosition.slot, oPosition.adList);
        oAdList = oPosition.adList;
      }

      //if there are already ads cached for this position but
      //the config has refresh = true, then get a new set of ads...
      else if (kAdList[sNormDomain][oPosition.region][oPosition.slot])
      {
        info('Using cached ads for ' + sNormDomain + ' in ' + oPosition.region + oPosition.slot);
        oAdList = kAdList[sNormDomain][oPosition.region][oPosition.slot];
      }
      else
      {
        throw {name: 'Warning', message: 'No ads found in cache for ' + sNormDomain + ' in ' + oPosition.region + oPosition.slot};
      }

      for (iAd in oAdList)
      {    	 
        // Ignore any expandable ads that are in a _popunder region
        if (oPosition.region == '_popunder' && (oAdList[iAd].type == 'expandable' || oAdList[iAd].type == 'pagecurl') )
        {
          info('Removing ad #' + oAdList[iAd].adid + ' because ' + oAdList[iAd].type + ' ads are not allowed in a popunder.');
          delete oAdList[iAd];
          continue;
        }

        //remove ads that have already been displayed
        //when the global variable TNCMS_Used_Ad is removed then kUsedAd can be used again...
        if (TNCMS_Used_Ad[iAd])
        {
          info('Removing ad #' + oAdList[iAd].adid + ' because it is already being displayed.');
          delete oAdList[iAd];
          continue;
        }

        if (!oAdList[iAd].uri && (oAdList[iAd].type == 'image' || oAdList[iAd].type == 'video'))
        {
          info('Removing ' + oAdList[iAd].type + ' ad #' + oAdList[iAd].adid + ' because it is missing the mandatory asset uri.');
          delete oAdList[iAd];
          continue;
        }

        //if it's an HTML ad *and* we're serving securly *but* the ad is not marked as secure then remove the ad
        if (oAdList[iAd].type == 'html' && location.protocol == 'https:' && !oAdList[iAd].secure)
        {
          info('Removing ad #' + oAdList[iAd].adid + ' because is not a secure HTML ad.');
          delete oAdList[iAd];
          continue;
        }

        //if there isn't a function to handle this ad type then throw it away!
        if (!kAdCallback[oAdList[iAd].type])
        {
          info('Removing ad #' + oAdList[iAd].adid + ' because it is of type (' + oAdList[iAd].type + ') and there is no callback registerd for that.');
          delete oAdList[iAd];
          continue;
        }

        //don't allow more than 16 DotConnect ads on any given page
        if (oAdList[iAd].type == 'dotconnect' && TNCMS_DotConnect_Tile > 16)
        {
          info('Removing ad #' + oAdList[iAd].adid + ' because it is a DotConnect ad and there are already 16 DoctConnect ads on this page.');
          delete oAdList[iAd];
          continue;
        }

        //if this ad has a keyword list and it's not empty then only allow this ad if it matches a meta keyword
        if (oAdList[iAd].keywords && Object.keys(oAdList[iAd].keywords).length !== 0)
        {
          bKeep = 0;

          //see if any of the ad's keywords match the meta keywords
          for (var sKey in oAdList[iAd].keywords)
          {
            //add spaces on either side to make the search matches the whole word only
            //lowercase the word so the search is case insensitive
            var oRegex = new RegExp(' ' + oAdList[iAd].keywords[sKey].toLowerCase() + ' ', '');

            if (sMetaKeywords.match(oRegex))
            {
              bKeep = 1;
              break;
            }
          }

          //if there are no matches, remove that ad
          if (!bKeep)
          {
            info('Removing ad #' + oAdList[iAd].adid + ' because it does not match any keywords on this page.');
            delete oAdList[iAd];
            continue;
          }
        }

        var oToday = new Date();
        var oStartDate = new Date();
        var oEndDate = new Date();
        var aDateParts = oAdList[iAd].startdate.split('-');
        oStartDate.setFullYear(aDateParts[0], (aDateParts[1]-1), aDateParts[2]);
        aDateParts = oAdList[iAd].enddate.split('-');
        oEndDate.setFullYear(aDateParts[0], (aDateParts[1]-1), aDateParts[2]);

        if (oStartDate > oToday)
        {
          info('Removing ad #' + oAdList[iAd].adid + ' because it has not yet started.');
          delete oAdList[iAd];
          continue;
        }

        if (oEndDate < oToday)
        {
          info('Removing ad #' + oAdList[iAd].adid + ' because it has already ended.');
          delete oAdList[iAd];
          continue;
        }

        //Throw out ads that do not fit the width limiter if present if width is defined in the ad. 
        if (oPosition.width && oAdList[iAd].width)
        {
          if (oAdList[iAd].width > oPosition.width)
          {
            info('Removing ad #' + oAdList[iAd].adid + ' because it is too wide for this region.');
            delete oAdList[iAd];
            continue;
          }
        }

        //throw out ads that have hit their impression limits
        if (kImpressions[sNormDomain]['daily'][iAd] && oAdList[iAd].dailyLimit && oAdList[iAd].dailyLimit <= kImpressions[oPosition.domain]['daily'][iAd])
        {
          info('Removing ad #' + oAdList[iAd].adid + ' because it has already met its daily impression limit.');
          delete oAdList[iAd];
          continue;
        }

        if (kImpressions[sNormDomain]['total'][iAd] && oAdList[iAd].totalLimit && oAdList[iAd].totalLimit <= kImpressions[oPosition.domain]['total'][iAd])
        {
          info('Removing ad #' + oAdList[iAd].adid + ' because it has already met its total impression limit.');
          delete oAdList[iAd];
          continue;
        }

        //do dayparting checks
        if (oAdList[iAd].daypart_enabled && oAdList[iAd].daypart_enabled != '')
        {
          //if dayparting is enabled on this ad but it has no schedule at all then the ad shouldn't run
          if (!oAdList[iAd].daypart_schedule)
          {
            info('Removing ad #' + oAdList[iAd].adid + ' because day parting is enabled but there is not schedule.');
            delete oAdList[iAd];
            continue;
          }

          var adSchedule = eval("(" + oAdList[iAd].daypart_schedule + ")");

          //if there is a schedule but the required day isn't set then the ad shouldn't run
          if (!adSchedule[oDayPart.day])
          {
            info('Removing ad #' + oAdList[iAd].adid + ' because day parting is enabled and this day is not in the schedule.');
            delete oAdList[iAd];
            continue;
          }

          //if there *is* a schedule and it's *not* set to "allday"
          if (!adSchedule[oDayPart.day].allday)
          {
            //and either bound is false then the ad shouldn't run 
            if (!adSchedule[oDayPart.day][oDayPart.startBound] || !adSchedule[oDayPart.day][oDayPart.endBound])
            {
              info('Removing ad #' + oAdList[iAd].adid + ' because day parting is enabled and it is not in the the start or end bound.');
              delete oAdList[iAd];
              continue;
            }
          }
        }

        //Frequency User Check if the user has seen this ad enough times dispatch it with severe prejudice!
        if (oAdList[iAd].frequency_limit)
        {
          //then we need to check the cookie to see what the current count is if it exists
          sValue = readCookie('tncms_ad_' + iAd);

          if (sValue)
          {
            aData = sValue.split('&');
            nAdCount = parseInt(aData[0], 10);

            if (nAdCount >= oAdList[iAd].frequency_limit)
            {
              info('Removing ad #' + oAdList[iAd].adid + ' because it has met its frequency limit.');
              delete oAdList[iAd];
              continue;
            }
          }
        }

        //if the lat, long and proximity are in the ad and the location has been detected
        //then only allow the ad if the ip-location is inside the proximity limit of the ad
        if (oAdList[iAd]['lat'] && oAdList[iAd]['long'] && oAdList[iAd].proximity && kLocation)
        {
          //ad lat / long are already in radians and so don't need converting.
          var sinDeltaLat = Math.sin(((kLocation['lat'] * Math.PI / 180) - oAdList[iAd]['lat']) / 2);
          var sinDeltaLong = Math.sin(((kLocation['long'] * Math.PI / 180) - oAdList[iAd]['long']) / 2);
          var a = Math.pow(sinDeltaLat, 2) + Math.pow(sinDeltaLong, 2) * Math.cos(oAdList[iAd]['lat']) * Math.cos(kLocation['lat'] * Math.PI / 180);

          if ((7974 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))) > oAdList[iAd].proximity)
          {
            info('Removing ad #' + oAdList[iAd].adid + ' because the reader was not detected within the configured porximity.');
            delete oAdList[iAd];
            continue;
          }
        }
      }

      if (oAdList.length == 0)
      {
        throw {name: 'Warning', message: 'All ads have been eliminated from the ad list for this position (' +  oPosition.region + oPosition.slot + ').'};
      }

      oSectionAds = getAdsBySection(oPosition.section, oAdList);
      sCurrentSection = oSectionAds.section;
      aAd = oSectionAds.ads;

      if (sCurrentSection == 'ros' && kSettings[sNormDomain]['sectionExclusions'])
      {
        for (var i = 0; i < kSettings[sNormDomain]['sectionExclusions'].length; i++)
        {          	
          if (kSettings[sNormDomain]['sectionExclusions'][i] == oPosition.section || window.location.href.indexOf("/" + kSettings[sNormDomain]['sectionExclusions'][i] + "/") > -1)
          {
            throw {name: 'Warning', message: 'ROS ads are excluded from this section (' + oPosition.section + ') so no ads will be displayed for this position (' + oPosition.region + oPosition.slot + ').'};
          }
        }
      }

      if (!aAd || aAd.length == 0)
      {
        throw {name: 'Warning', message: 'There are no ads available in this section (' + oPosition.section + ') for this position (' + oPosition.region + oPosition.slot + ').'};
      }
      
      var nIterator = 0;
      var nLockedTotalPerc = 0;
      var nLimitedPerc = 0;
      var nUnlockedTotalPerc = 0;
      var nUnlockedAds = 0;
      var nNoAd = 0;

      for (var i=0; i < aAd.length; i++)
      {
        aAd[i].weight = getAdWeightData(aAd[i], sCurrentSection, sNormDomain);

        if (aAd[i].weight.locked == 1)
        {
          nLockedTotalPerc += parseFloat(aAd[i].weight.percent);
          aAd[i].minRange = nIterator;
          aAd[i].maxRange = nIterator + (10000 * parseFloat(aAd[i].weight.percent));
          info('Weight range for ad #' + aAd[i].adid + ': ' + aAd[i].minRange + ' to ' + aAd[i].maxRange);
          nIterator = aAd[i].maxRange;
        }
        else if (aAd[i].weight.locked == 2)
        {
          nLimitedPerc += parseFloat(aAd[i].weight.percent);
        }
        else
        {
          nUnlockedTotalPerc += parseFloat(aAd[i].weight.percent);
          nUnlockedAds++;
        }
      }

      if ((nLimitedPerc + nUnlockedTotalPerc) > (100 - nLockedTotalPerc))
      {
        nMultiplier = (100 - nLockedTotalPerc) / 100;

        for (i = 0; i < aAd.length; i++)
        {
          if (aAd[i].weight.locked != 1)
          {
            aAd[i].minRange = nIterator;
            aAd[i].maxRange = nIterator + (10000 * parseFloat(aAd[i].weight.percent) * nMultiplier);
            info('Weight range for ad #' + aAd[i].adid + ': ' + aAd[i].minRange + ' to ' + aAd[i].maxRange);
            nIterator = aAd[i].maxRange;
          }
        }
      }
      else if ((nLimitedPerc + nUnlockedTotalPerc) <= (100 - nLockedTotalPerc))
      {
        if (nUnlockedTotalPerc == 0)
        {
          nNoAd = 100 - nLockedTotalPerc - nLimitedPerc;

          for (i = 0; i < aAd.length; i++)
          {
            if (aAd[i].weight.locked != 1)
            {
              aAd[i].minRange = nIterator;
              aAd[i].maxRange = nIterator + (10000 * parseFloat(aAd[i].weight.percent));
              info('Weight range for ad #' + aAd[i].adid + ': ' + aAd[i].minRange + ' to ' + aAd[i].maxRange);
              nIterator = aAd[i].maxRange;
            }
          }
        }
        else
        {
          nNewPercent = (100 - nLockedTotalPerc - nLimitedPerc) / nUnlockedAds;

          for (i = 0; i < aAd.length; i++)
          {
            if (aAd[i].weight.locked != 1)
            {
              nPercent = aAd[i].weight.locked < 1 ? nNewPercent : aAd[i].weight.percent;
              aAd[i].minRange = nIterator;
              aAd[i].maxRange = nIterator + (10000 * parseFloat(nPercent));
              info('Weight range for ad #' + aAd[i].adid + ': ' + aAd[i].minRange + ' to ' + aAd[i].maxRange);
              nIterator = aAd[i].maxRange;
            }
          }
        }
      }

      nIterator += nNoAd;
      var randomWeight = Math.floor(Math.random() * nIterator);

      for (var i=0; i < aAd.length; i++)
      {
        if (aAd[i].minRange <= randomWeight && aAd[i].maxRange > randomWeight)
        {
          info('Ad #' + aAd[i].adid + '(type: ' + aAd[i].type + ') chosen from ' + oPosition.domain + ' to display in ' + oPosition.region + oPosition.slot);

          //copies have to be done this way because simple assignment actually creates a reference and not a copy
          oAd = Object.create(aAd[i]);

          //assign any field in oPosition that is not alreay in oAd  
          for (sFieldName in oPosition)
          {
            if (sFieldName != 'finalRender' && !oAd[sFieldName])
            {
              oAd[sFieldName] = oPosition[sFieldName];
            }
          }

          //hard set these items
          oAd.originalSection = oPosition.section;
          oAd.section = sCurrentSection;
          oAd.position = oPosition.region + oPosition.slot;

          if (oAd.cdn)
          {
            oAd.asseturl = 'https://' + oAd.cdn + oAd.uri;
          }

          oAd.window = window;

          if (iDebug & 1 && (typeof(kVirtualRegionCallback[oAd.regionType]) != 'function'))
          {
            debugHeaderDiv = document.getElementById('blox-ad-position-debug-header-' + oAd.position);

            if (debugHeaderDiv)
            {
              //if the debugHeaderDiv already exists then all we need to do is set the positionDiv
              oAd.positionDiv = document.getElementById('blox-ad-position-' + oAd.position);
            }
            else
            {
              //reset the current position div and change it to the new debug div
              debugDiv = document.getElementById('blox-ad-position-' + oAd.position);
              debugDiv.setAttribute('id', 'blox-ad-position-debug-' + oAd.position);

              //create the header div
              debugHeaderDiv = document.createElement('div');
              debugHeaderDiv.style.border = '1px solid black';
              debugHeaderDiv.style.width = '100%';
              debugHeaderDiv.setAttribute('id', 'blox-ad-position-debug-header-' + oAd.position);

              //add the headerDiv as a child to the debugDiv
              debugDiv.appendChild(debugHeaderDiv);

              //create the new positionDiv
              oAd.positionDiv = document.createElement('div');
              oAd.positionDiv.setAttribute('id', 'blox-ad-position-' + oAd.position);

              //add the new positionDiv as a child to the debugDiv
              debugDiv.appendChild(oAd.positionDiv);
            }

            debugHeaderDiv.innerHTML = ' Ad Position: ' + oAd.section + ' : ' + oAd.region + ' : ' + oAd.slot + ' Ad ID: ' + oAd.adid + ' (' + oAd.type + ':API 2)';
          }
          else
          {
            oAd.positionDiv = document.getElementById('blox-ad-position-' + oAd.position);
          }

          if ( oAd.clickuri ) {
        	  
              clickuri = oAd.clickuri.match(/^[htpsmailo]+:/i) ? oAd.clickuri : 'http://' + oAd.clickuri;
              oAd.clickuri = TNCMS.Tracking.getRedirectURL
              ({
                domain: TNCMS.AdManager.isSecure ? oAd.secureDomain : oAd.domain,
                app: 'bannerad',
                metric: 'clicks',
                id: oAd.section + '/' + oAd.position + '/' + oAd.uuid,
                url: clickuri
              });
              
          } else if ( oAd.type == 'html' && oAd.html ) {
        	  
            trackerURL = location.protocol + TNCMS.Tracking.getRedirectURL
            ({
              domain: TNCMS.AdManager.isSecure ? oAd.secureDomain : oAd.domain,
              app: 'bannerad',
              metric: 'clicks',
              id: oAd.section + '/' + oAd.position + '/' + oAd.uuid,
              url: 'TNCMS_AD_TRACKER'
            });
            trackerURL = trackerURL.replace(/TNCMS_AD_TRACKER/, '');
            html = eval(oAd.html);
            oAd.html = html.replace(/__TRACKER_URL__/g, trackerURL);
            
          }

          if (oAd.type == 'video')
          {
            //if there are no settings for this postions then use the defaults...
            oAd.rolltype = 'pre';
            oAd.autoplay = 0;
            oAd.embed = 0;
            oAd.volume = 50;

            //if there are any settings for the position + section then use those instead of the defaults
            if (kSettings[normDomain(oAd.domain)][oAd.region][oAd.slot] && kSettings[normDomain(oAd.domain)][oAd.region][oAd.slot][oAd.section])
            {
              var kSectionSettings = kSettings[normDomain(oAd.domain)][oAd.region][oAd.slot][oAd.section];
              oAd.rolltype = kSectionSettings.video_rolltype || oAd.rolltype;
              oAd.autoplay = kSectionSettings.video_autoplay ? parseInt(kSectionSettings.video_autoplay, 10) : oAd.autoplay;
              oAd.embed = kSectionSettings.video_embed ? parseInt(kSectionSettings.video_embed, 10) : oAd.embed;
              oAd.volume = kSectionSettings.video_volume ? parseInt(kSectionSettings.video_volume, 10) : oAd.volume;
            }
          }

          return oAd;
        }
      }

      //if you get here then there was no ad selected randomly...
      throw {name: 'Warning', message: 'No ad was selected from the list'};
    }

    function getAdWeightData(oCurrentAd, sAdSection, sAdDomain)
    {
    	sAdDomain = normDomain(sAdDomain);
    	
      for (adSection in oCurrentAd.weights)
      {
        if (adSection == sAdSection)
        {
          if (!kSettings[sAdDomain]['trafficSmoothing'] || (oCurrentAd.ad_balancing == 'asap'))
          {
            info('On ' + sAdDomain + ' using default weights (ASAP) for ad#' + oCurrentAd.adid);
            return oCurrentAd.weights[adSection];
          }

          //if the traffic data is not set the simply return the default value...
          if (!kTraffic[sAdDomain]['estimate'] || !kTraffic[sAdDomain]['ratio'])
          {
            warn('No traffic data found for ' + sAdDomain + ': using default weights for ad#' + oCurrentAd.adid);
            return oCurrentAd.weights[adSection];
          }

          //this is the new section and if new data exists
          //and the nTrafficRatio and nTrafficEstimate are greater than zero
          //then we use this instead of the pre-set value
          var oDate = new Date();
          iHour = oDate.getHours();
          nTrafficEstimate = kTraffic[sAdDomain]['estimate'][iHour] || 0;
          nTrafficRatio = kTraffic[sAdDomain]['ratio'][iHour] || 0;

          if (oCurrentAd.dailyLimit && kImpressions[sAdDomain]['daily'][oCurrentAd.adid] && nTrafficRatio && nTrafficEstimate)
          {
            nWantedImpressions = (oCurrentAd.dailyLimit - kImpressions[sAdDomain]['daily'][oCurrentAd.adid]) * nTrafficRatio;

            //if the nWantedImpressions is greater than or equal to the current nTrafficEstimate
            //then it should have to have a normal (unadjusted) chance along with all the non-limited ads
            //otherwise the limited ads will get a disproprtionately large percentage of the this section's impressions
            if (nWantedImpressions >= nTrafficEstimate)
            {
              info('Wanted impressions for ' + oCurrentAd.adid + ' is greater than the current traffic estimate: using default weights for ad#' + oCurrentAd.adid);
              return oCurrentAd.weights[adSection];
            }

            nWeight = nWantedImpressions / nTrafficEstimate;
            info('Overriding default weight: using traffic curve for ad#' + oCurrentAd.adid);
            return {'section': sAdSection, 'percent': 100 * nWeight, 'locked': 2};
          }

          info('Using default weight in favor of traffic curve for ad#' + oCurrentAd.adid);
          return oCurrentAd.weights[adSection];
        }
      }

      warn('No weight data found for ad#' + oCurrentAd.adid + ' found: using 0');
      return 0;
    }

    function getAdsBySection(sTestSection, oAds)
    {
      oValidAds = [];

      for (nAdId in oAds)
      {
        var adSections = oAds[nAdId].sections;

        for (var i=0; i < adSections.length; i++)
        {
          if (adSections[i] == sTestSection)
          {
            oValidAds.push(oAds[nAdId]);
          }
        }
      }

      //Need to recursively attempt to find ads and adjust the section we are working on to where we find ads. 
      //if any ads are found or if we are already testing ROS ads
      if (oValidAds.length > 0 || sTestSection == 'ros')
      {
        //then return the current list of ads
        info('Returning ads for section: ' + sTestSection);
        return {section: sTestSection, ads: oValidAds};
      }

      //otherwise try recursing up one section
      sMatch = sTestSection.match(/(\/[\w\-]+)$/g);
      if (sMatch)
      {
        return getAdsBySection(sTestSection.replace(sMatch, ''), oAds);
      }

      //if there are no sections to recurse up to then test ROS ads
      return getAdsBySection('ros', oAds);
    }

    function readCookie(name)
    {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');

      for (var i=0; i < ca.length; i++)
      {
        var c = ca[i];

        while (c.charAt(0) == ' ')
        {
          c = c.substring(1, c.length);
        }

        if (c.indexOf(nameEQ) == 0)
        {
          return c.substring(nameEQ.length, c.length);
        }
      }

      return null;
    }

    /**
    (c) Gregers Rygg - MIT License
    Tweaked to work better within the admanager.js environment
    */
    var jsLoader = (function()
    {
      var isActive = false,
        queue = [],
        inputBuffer = [],
        writeBuffer = {},
        loading = 0,
        elementCache = {},
        returnedElements = [],
        splitScriptsRegex = /(<script[\s\S]*?<\/script>)/gim,
        publ = null,
        head = document.getElementsByTagName('head')[0] || document.documentElement,
        splitWithCapturingParentheses = 'abc'.split(/(b)/)[1] === 'b';

      function checkQueue()
      {
        if (queue.length)
        {
          loadScript(queue.shift());
        }
        else if (loading === 0)
        {
          info('jsLoader: Auto-releasing');
          publ.release();
        }
      }

      function checkWriteBuffer(obj)
      {
        var buffer = writeBuffer[obj.domId],
          returnedEl;

        if (buffer && buffer.length)
        {
          writeHtml(buffer.shift(), obj);
        }
        else
        {
          while (returnedElements.length > 0)
          {
            returnedEl = returnedElements.pop();
            var id = returnedEl.id;
            var elInDoc = getElementById(id);
            
            if (!elInDoc)
            {
              continue;
            }
            
            var parent = elInDoc.parentNode;
            elInDoc.id = id + '__tmp';
            parent.insertBefore(returnedEl, elInDoc);
            parent.removeChild(elInDoc);
          }

          checkQueue();
        }
      }

      function flush(obj)
      {
        var domId = obj.domId,
          outputFromScript,
          htmlPartArray;

        outputFromScript = stripNoScript(inputBuffer.join(""));
        inputBuffer = [];
        htmlPartArray = separateScriptsFromHtml(outputFromScript);

        if (!writeBuffer[domId])
        {
          writeBuffer[domId] = htmlPartArray;
        }
        else
        {
          Array.prototype.unshift.apply(writeBuffer[domId], htmlPartArray);
        }

        checkWriteBuffer(obj);
      }

      function getCachedElById(domId)
      {
        return elementCache[domId] || (elementCache[domId] = document.getElementById(domId));
      }

      function getElementById(domId)
      {
        return (publ.originalGetElementById.call ? publ.originalGetElementById.call(document, domId) : publ.originalGetElementById(domId));
      }

      function getElementByIdReplacement(domId)
      {
        var el = getElementById(domId),
          html, frag, div, found;

        function traverseForElById(domId, el)
        {
          var children = el.children, i, l, child;

          if (children && children.length)
          {
            for(i=0, l=children.length; i<l; i++)
            {
              child = children[i];

              if (child.id && child.id === domId)
              {
                return child;
              }
              
              if (child.children && child.children.length)
              {
                var tmp = traverseForElById(domId, child);
                
                if (tmp)
                {
                  return tmp;
                }
              }
            }
          }
        }

        function searchForAlreadyReturnedEl(domId)
        {
          var i, l, returnedEl;

          for (i = 0, l = returnedElements.length; i < l; i++)
          {
            returnedEl = returnedElements[i];

            if (returnedEl.id === domId)
            {
              return returnedEl;
            }
          }
        }

        if (el)
        {
          return el;
        }

        if (returnedElements.length)
        {
          found = searchForAlreadyReturnedEl(domId);

          if (found)
          {
            return found;
          }
        }

        if (inputBuffer.length)
        {
          html = inputBuffer.join('');
          frag = document.createDocumentFragment();
          div = document.createElement('div');
          div.innerHTML = html;
          frag.appendChild(div);
          found = traverseForElById(domId, div);

          if (found)
          {
            returnedElements.push(found);
          }

          return found;
        }
      }

      var globalEval = (function()
      {
        return (window.execScript ? function(code, language){window.execScript(code, language || 'JavaScript');} : function(code, language) {if(language && !/^javascript/i.test(language)) { return; } window.eval.call(window, code);});
      }());

      function isScript(html)
      {
        return html.toLowerCase().indexOf('<script') === 0;
      }

      function loadScript(obj)
      {
        loading++;
        // async loading code from jQuery
        var script = document.createElement('script');

        if (obj.type)
        {
          script.type = obj.type;
        }

        if (obj.charset)
        {
          script.charset = obj.charset;
        }

        if (obj.language)
        {
          script.language = obj.language;
        }

        logScript(obj);
        var done = false;

        // Attach handlers for all browsers
        script.onload = script.onreadystatechange = function()
        {
          loading--;
          script.loaded = true;

          if (!done && (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete'))
          {
            done = true;
            script.onload = script.onreadystatechange = null;
            info('jsLoader: #' + obj.domId + ': onload ' + obj.src);
            flush(obj);
          }
        };

        script.loaded = false;
        script.src = obj.src;

        // Use insertBefore instead of appendChild to circumvent an IE6 bug.
        // This arises when a base node is used (#2709 and #4378).
        head.insertBefore(script, head.firstChild);
        setTimeout(function()
        {
          if (!script.loaded)
          {
            throw new Error('jsLoader: SCRIPT NOT LOADED: ' + script.src);
          }
        }, 3000);
      }

      function logScript(obj, code, lang)
      {
        info('jsLoader: #' + obj.domId + (code ? ': Inline ' + lang + ': ' + code.replace("\n", ' ').substr(0, 30) + '...' : ': Inject ' + obj.src));
      }

      function separateScriptsFromHtml(htmlStr)
      {
        return split(htmlStr, splitScriptsRegex);
      }

      function split(str, regexp)
      {
        var match, prevIndex = 0, tmp, result = [], i, l;

        if (splitWithCapturingParentheses)
        {
          tmp = str.split(regexp);
        }
        else
        {
          // Cross browser split technique from Steven Levithan
          // http://blog.stevenlevithan.com/archives/cross-browser-split
          tmp = [];

          while (match = regexp.exec(str))
          {
            if (match.index > prevIndex)
            {
              result.push(str.slice(prevIndex, match.index));
            }

            if (match.length > 1 && match.index < str.length)
            {
              Array.prototype.push.apply(tmp, match.slice(1));
            }

            prevIndex = regexp.lastIndex;
          }

          if (prevIndex < str.length)
          {
            tmp.push(str.slice(prevIndex));
          }
        }

        for (i = 0, l = tmp.length; i < l; i = i + 1)
        {
          if (tmp[i] !== '')
          {
            result.push(tmp[i]);
          }
        }

        return result;
      }

      function stripNoScript(html)
      {
        return html.replace(/<noscript>[\s\S]*?<\/noscript>/ig, '');
      }

      function trim(str)
      {
        if (!str)
        {
          return str;
        }
        
        return str.replace(/^\s*|\s*$/gi, '');
      }

      function writeHtml(html, obj)
      {
        if (isScript(html))
        {
          var dummy = document.createElement('div');
          dummy.innerHTML = 'dummy<div>' + html + '</div>'; // trick for IE
          var script = dummy.children[0].children[0];
          var lang = script.getAttribute('language') || 'javascript';

          if (script.src)
          {
            obj.src = script.src;
            obj.charset = script.charset;
            obj.language = lang;
            obj.type = script.type;
            loadScript(obj);
          }
          else
          {
            var code = trim(script.text);

            if (code)
            {
              logScript(obj, code, lang);
              globalEval(code, lang);
            }

            flush(obj);
          }
        }
        else
        {
          var container = getCachedElById(obj.domId);

          if (!container)
          {
            throw new Error('jsLoader: Unable to inject html. Element with id "' + obj.domId + '" does not exist');
          }
          
          html = trim(html); // newline before <object> cause weird effects in IE

          if (html)
          {
            container.innerHTML += html;
          }

          checkWriteBuffer(obj);
        }
      }

      function writeReplacement(str)
      {
        inputBuffer.push(str);
        info('jsLoader: write: ' + str);
      }

      function openReplacement()
      {
        // document.open() just returns the document when called from a blocking script:
        // http://www.whatwg.org/specs/web-apps/current-work/#dom-document-open
        return document;
      }

      function closeReplacement()
      {
        // document.close() does nothing when called from a blocking script:
        // http://www.whatwg.org/specs/web-apps/current-work/#dom-document-close
      }

      publ =
      {
        activate: function()
        {
          if (isActive)
          {
            return;
          }
          
          document.write = document.writeln = writeReplacement;
          document.open = openReplacement;
          document.close = closeReplacement;
          document.getElementById = getElementByIdReplacement;
          isActive = true;
        },

        release: function()
        {
          if (!isActive)
          {
            return;
          }

          document.write = this.originalWrite;
          document.writeln = this.originalWriteLn;
          document.open = this.originalOpen;
          document.close = this.originalClose;
          document.getElementById = this.originalGetElementById;
          elementCache = {};
          isActive = false;
        },

        loadScript: function(src, domId)
        {
          if (typeof domId !== 'string')
          {
            throw new Error('jsLoader: No valid DOM ID found for ' + src);
          }

          if (!isActive)
          {
            info('jsLoader: Auto-activating');
            this.activate();
          }

          queue.push({src: src, domId: domId});
          setTimeout(function()
          {
            if (loading === 0)
            {
              checkQueue();
            }
          }, 1);
        },

        originalGetElementById: document.getElementById,
        originalWrite: document.write,
        originalWriteLn: document.writeln,
        originalOpen: document.open,
        originalClose: document.close
      };

      return publ;
    }());

    return  {
      //allow public access to these functions
      info: info,
      warn: warn,
      error: error,
      init: init,
      setImpressions: setImpressions,
      setTraffic: setTraffic,
      setSettings: setSettings,
      setAds: setAds,
      render: render,
      renderAd: renderAd,
      refresh: refresh,
      isSecure: isSecure
    };
  })();
}